
/* injects from baggage-loader */

'use strict';

export default class statusBarController {
    constructor($log, $rootScope, $element, $timeout, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.Trophies = Trophies;

        this.totals = {
            lifes: 3,
            stars: 5,
            chef: 5
        }
    }
    getTotalCollected(){
        return this.Trophies.totalCollected();
    }
    
    getChefTotalCollected(){
        return this.Trophies.totalChefCollected();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/status-bar/status-bar.controller.js